/* 🤖 this file was generated by svg-to-ts */
export const matIconKeyboardArrowDown: {
  name: 'keyboard-arrow-down';
  data: string;
} = {
  name: 'keyboard-arrow-down',
  data: `<svg xmlns="http://www.w3.org/2000/svg" width="24" height="24"><path d="M7.41 8.59 12 13.17l4.59-4.58L18 10l-6 6-6-6 1.41-1.41z"/></svg>`
};
